export const CURRENCIES = ['SEK', 'USD', 'EUR'];
